
import { RevealOnScroll } from "@/components/ui/reveal-on-scroll";
import ditchImg from "@/assets/ditch-guesswork.png";
import tickIcon from "@/assets/tick-icon.png";
import invoiceDoodle from "@/assets/invoice-doodle.svg";

const ditchBullets = [
  "Measure rooms in seconds.",
  "Generate professional and detailed quotes on-site while you're with your client.",
  "Get digital sign-offs before you leave the appointment."
];

const growBullets = [
  { emoji: "🍻", text: "A cold one with mates at the local." },
  { emoji: "🏉", text: "Tossing the footy with your kids." },
  { emoji: "⛺️", text: "Leaving earlier for that camping or fishing trip." }
];

function Feature() {
  return <div className="w-full py-20 lg:py-[10px] overflow-hidden">
      <div className="container mx-auto">
        <div className="flex flex-col-reverse lg:flex-row gap-10 lg:items-center">
          <RevealOnScroll direction="left" distance={120} delay={200} className="flex-1">
            <div className="relative rounded-3xl w-full aspect-[4/3] h-full overflow-hidden">
              <img src={ditchImg} alt="Painters using Quickatoo on a tablet" className="w-full h-full object-cover" />
            </div>
          </RevealOnScroll>
          <RevealOnScroll direction="right" distance={120} delay={400} className="flex gap-4 pl-0 lg:pl-20 flex-col flex-1">
            <div className="flex gap-4 flex-col">
              <h2 className="font-display text-3xl md:text-4xl lg:text-[44px] leading-[1.2] lg:max-w-xl text-left text-quickatoo-purple">Ditch the Guesswork. Quote like a Pro!</h2>
              <div className="space-y-4">
                <p className="text-lg leading-relaxed text-quickatoo-charcoal/80 text-left">
                  Aussie painters waste 20+ hours a week on dodgy measurements, messy spreadsheets, and chasing clients for approvals.
                </p>
                <div className="text-left">
                  <h3 className="text-lg font-semibold mb-3 text-quickatoo-charcoal">With Quickatoo on hand:</h3>
                  <ul className="space-y-3">
                    {ditchBullets.map((text) => (
                      <li key={text} className="flex items-start gap-3">
                        <img src={tickIcon} alt="" className="h-5 w-auto flex-shrink-0 mt-1" />
                        <span className="text-base text-quickatoo-charcoal">{text}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </RevealOnScroll>
        </div>
      </div>

      <div className="container mx-auto mt-20">
        <div className="flex flex-col lg:flex-row gap-10 lg:items-center">
          <RevealOnScroll direction="left" distance={120} delay={400} className="flex gap-4 pr-0 lg:pr-20 flex-col flex-1">
            <div className="flex gap-4 flex-col">
              <h2 className="font-display text-3xl md:text-4xl lg:text-[44px] leading-[1.2] lg:max-w-xl text-left text-quickatoo-purple">Grow your business &amp; cut out the paperwork.</h2>
              <div className="space-y-4">
                <p className="text-lg leading-relaxed text-quickatoo-charcoal/80 text-left">
                  Spend less time quoting and more time doing… well, what you'd rather be doing! Like:
                </p>
                <div className="text-left">
                  <ul className="space-y-3">
                    {growBullets.map(({ emoji, text }) => (
                      <li key={text} className="flex items-start gap-3">
                        <span className="text-xl">{emoji}</span>
                        <span className="text-base text-quickatoo-charcoal">{text}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <p className="text-lg font-semibold text-left text-quickatoo-charcoal">Quickatoo gives you better control over your time and money.</p>
              </div>
            </div>
          </RevealOnScroll>
          <RevealOnScroll direction="right" distance={120} delay={200} className="flex-1">
            <div className="bg-quickatoo-yellow rounded-3xl w-full aspect-[4/3] h-full overflow-hidden flex items-center justify-center gap-6 p-8 md:p-12">
              <img src={invoiceDoodle} alt="" className="w-2/5 max-w-[220px]" />
              <div className="text-left text-quickatoo-charcoal">
                <div className="font-display text-8xl md:text-9xl leading-none">3x</div>
                <div className="font-display text-2xl md:text-3xl leading-tight mt-2">more quotes.<br />0 extra time.</div>
              </div>
            </div>
          </RevealOnScroll>
        </div>
      </div>
    </div>;
}
export { Feature };
